import React from 'react';

const Instructions = (props) => {
    let { currentInstructions, labels, getNextQuestion } = props;
    return(
        <div className="m-portlet m-portlet--primary m-portlet--head-solid-bg">
            <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                        <h2 className="m-portlet__head-text">{ currentInstructions.Titulo }</h2>
                    </div>
                </div>
            </div>
            <div className="m-portlet__body">
                <p>{ currentInstructions.Instrucciones }</p>
            </div>

            <div className="m-portlet__foot">
                <button className="btn m-btn--square btn-primary"
                        onClick={getNextQuestion}>{ labels.Siguiente }</button>
            </div>
        </div>
    );
};

export default Instructions;
